import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Fulfillment({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Fulfillment.Outline {...props} />
  ) : (
    <Fulfillment.Solid {...props} />
  );
}

Fulfillment.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M4 16.8481C4 17.2069 4.19238 17.5382 4.50391 17.7162L11.5039 21.7162C11.8113 21.8919 12.1887 21.8919 12.4961 21.7162L19.4961 17.7162C19.8076 17.5382 20 17.2069 20 16.8481V8.91057C20 8.5533 19.8094 8.22299 19.5 8.04436L12.5 4.00334C12.1906 3.82471 11.8094 3.82471 11.5 4.00334L4.5 8.04436C4.1906 8.22299 4 8.5533 4 8.91057V16.8481ZM21.5 16.8481C21.5 17.7452 21.0192 18.5739 20.2402 19.019L13.2402 23.019C12.4717 23.4581 11.5283 23.4581 10.7598 23.019L3.75977 19.019C2.98083 18.5739 2.5 17.7452 2.5 16.8481V8.91057C2.5 8.01743 2.97654 7.19212 3.75 6.74553L10.75 2.70354L10.8975 2.62541C11.5925 2.28372 12.4075 2.28372 13.1025 2.62541L13.25 2.70354L20.25 6.74553C21.0235 7.19212 21.5 8.01743 21.5 8.91057V16.8481Z"
          fill="currentColor"
        />
        <path
          d="M20.3721 8.93707L12 13.7213L3.62793 8.93707L4.37207 7.63434L12 11.9927L19.6279 7.63434L20.3721 8.93707Z"
          fill="currentColor"
        />
        <path
          d="M12.75 12.8571V21.9997H11.25V12.8571H12.75Z"
          fill="currentColor"
        />
        <path
          d="M15.7501 13.3572V10.7859L7.62026 6.00366L8.38002 4.71069L17.2501 9.92846V13.3572C17.2501 13.7714 16.9144 14.1072 16.5001 14.1072C16.0859 14.1072 15.7501 13.7714 15.7501 13.3572Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Fulfillment.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
